export default __webpack_public_path__ + "static/media/higher_primary_logo_tagline_reversed.1961960d.svg";